<div class="header-title" [class.add-opacity]="editDisabled">Logo<span *ngIf="required">*</span></div>
<div [class.logo-wrapper]="!fullView" [class.full-view-logo-wrapper]="fullView">
    <div *ngIf="fileId" [class.img-container]="!fullView" [class.full-view-img-container]="fullView" [class]="{'edit-disabled-style': editDisabled}">
        <img [class.img]="!fullView" [class.full-view-img]="fullView" [src]="imagePath(fileId)" />
    </div>
    <div *ngIf="!fileId" class="img-default-container" (click)="onDefaultContainerClick()" [class.add-opacity]="editDisabled">
        <img
            [class.img-default]="!fullView"
            [class.full-view-img-default]="fullView" 
            src="assets/svg-icons/upload_icon.svg"
        />
        <span>Datei hochladen</span>
    </div>
    <div class="logo-button-panel" *ngIf="!editDisabled">
        <app-file-upload #logoUpload class="bgn-icon" [buttonIcon]="'Edit'" [allowMultipleUploads]="false"
            [acceptedFileTypes]="'image/*'" (selected)="onLogoChanged($event[0])"></app-file-upload>
        <red-trash-can-button class="bgn-icon" (click)="removeLogo()"></red-trash-can-button>
    </div>
</div>